



















































import { Type, AnyType, Expression } from 'expangine-runtime';
import { LiveRuntime } from 'expangine-runtime-live';
import { AnyOptions } from './AnyTypes';
import { TypeSettings, TypeUpdateEvent } from '../TypeVisuals';
import { getBuildType } from '../../../app/BuildType';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<AnyType, AnyOptions, any>().extend({
  name: 'Any',
  data: () => ({
    anyType: null as null | Type,
    anySettings: null as null | TypeSettings,
    designing: false,
    fullscreen: false,
  }),
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    designLabel(): string {
      return this.settings.options.designLabel || 'Design';
    }, 
  },
  watch: {
    value: {
      immediate: true,
      handler(value: any) {
        const detectedType = this.registry.defs.describe(value);
        if (!this.anyType || !detectedType.acceptsType(this.anyType)) {
          this.anyType = detectedType;
          this.anyType.removeDescribedRestrictions();
          this.anySettings = this.registry.getTypeSettings(detectedType);
        }
      },
    },
  }, 
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;
    },
    async design() {
      if (!this.anyType) {
        const buildType = await getBuildType({ title: 'Choose Any Type' });
        if (buildType) {
          this.anyType = buildType.type;
          this.anySettings = buildType.settings;
          this.designing = true;
        }
      } else {
        this.designing = true;
      }
    },
    onChange(event: TypeUpdateEvent) {
      this.anyType = event.type;
      this.anySettings = event.settings;

      if (event.transform instanceof Expression) {
        const cmd = LiveRuntime.getCommand(event.transform);

        this.computedValue = cmd({ value: this.value });
      }
    },
  },
});
